import { render, staticRenderFns } from "./Occupation.vue?vue&type=template&id=56d074dd&"
import script from "./Occupation.vue?vue&type=script&lang=js&"
export * from "./Occupation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports